import { render, staticRenderFns } from "./guestbookCard.vue?vue&type=template&id=3daab278&"
import script from "./guestbookCard.vue?vue&type=script&lang=js&"
export * from "./guestbookCard.vue?vue&type=script&lang=js&"
import style0 from "./guestbookCard.vue?vue&type=style&index=0&id=3daab278&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports